import { useState, useEffect } from "react";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Serviços", href: "#services" },
  { label: "Frota", href: "#fleet" },
  { label: "Sobre Nós", href: "#about" },
  { label: "Depoimentos", href: "#testimonials" },
  { label: "Contato", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "bg-black/95 shadow-lg border-b border-slate-400/30" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
        {/* Logo */}
        <a href="#home" onClick={() => handleNav("#home")} className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/fe5c18211bf500b7fcedb51dc1a1fe0b.png"
            alt="Transporte Menezes Logo"
            className="h-48 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.href}>
              <button
                onClick={() => handleNav(link.href)}
                className="text-sm font-medium text-gray-300 hover:text-slate-200 transition-colors duration-300 tracking-wide uppercase cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </button>
            </li>
          ))}
        </ul>

        {/* CTA Button */}
        <button
          onClick={() => handleNav("#contact")}
          className="hidden md:flex items-center gap-2 bg-slate-300 hover:bg-white text-black text-sm font-bold px-6 py-2.5 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-phone-line"></i>
          Reservar Agora
        </button>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden text-slate-300 text-2xl cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-3-line"}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-black/98 border-t border-slate-400/30 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNav(link.href)}
              className="text-sm font-medium text-gray-300 hover:text-slate-200 transition-colors text-left uppercase tracking-wide cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => handleNav("#contact")}
            className="bg-slate-300 hover:bg-white text-black text-sm font-bold px-6 py-2.5 rounded-md transition-all cursor-pointer whitespace-nowrap"
          >
            Reservar Agora
          </button>
        </div>
      )}
    </nav>
  );
}
